<ng-container
  *ngFor="
    let option of props.options | formlySelectOptions: field | async;
    let i = index
  "
>
  <mat-checkbox
    [id]="id + '_' + i"
    [formlyAttributes]="field"
    [tabIndex]="props.tabindex"
    [color]="props.color"
    [labelPosition]="props.labelPosition || 'after'"
    [checked]="isChecked(option)"
    [disabled]="formControl.disabled || option.disabled"
    (change)="onChange(option.value, $event.checked)"
  >
    {{ option.label }}
  </mat-checkbox>
</ng-container>
